<template>
  <div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousEx"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="35"></md-layout>

          <md-layout md-flex>
            <h2>Consol Master Merge</h2>

            <md-layout md-flex="45"></md-layout>

            <md-layout md-flex="30"></md-layout>
          </md-layout>
        </md-layout>
        <hr class="hr-border">

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <md-layout md-flex="100">
              <label>MAWB NO.</label>

              <b-form-input :formatter="capitalizeAll" v-model="consolModel.MAWBNumber"></b-form-input>
            </md-layout>
          </md-layout>
        </md-layout>

        <div class="box">
          <!-- /.box-header -->
          <div class="box">
            <div class="box-header">
              <h3 class="box-title">
                <u>Consol Master Details House Bill Wise</u>
              </h3>
            </div>

            <!-- /.box-header -->
            <div class="box-body">
              <table id="shiper" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Sr.no</th>

                    <th>Client Name</th>

                    <th>HAWB No.</th>

                    <th>HAWB Date</th>

                    <th>Commodity Name</th>

                    <th>HSN Code</th>
                    <th>No. of Pkg.</th>

                    <th>Total Gross Wgt.</th>

                    <th>Total Volume Wgt.</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item1,index) in cansolMasterMergeTable" :key="index">
                    <td>{{index+1}}</td>

                    <td>{{item1.clientName}}</td>
                    <td>{{item1.HAWBNumber}}</td>
                    <td>{{item1.HAWBDate | moment}}</td>
                    <td>{{item1.itemName }}</td>
                    <td>{{item1.hsnCode}}</td>
                    <td>{{item1.noOfPackage}}</td>
                    <td>{{item1.cargoGrossWeight}}</td>
                    <td>{{item1.cargoVolumeWeight}}</td>
                  </tr>

                  <tr style="border-top:1px solid #000;font-size:16px">
                    <td colspan="7" style="text-align:right;padding-right:5%;">
                      <b>Total Cargo Weight</b>
                    </td>
                    <td>
                      <b>{{consolModel.totalcargoGrossWeight}}</b>
                    </td>
                    <td>
                      <b>{{consolModel.totalcargoVolumeWeight}}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- /.box-body -->
          </div>

          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Chargaeable Volume Wgt By System</label>

                <b-form-input :formatter="capitalizeAll" v-model="consolModel.totalchargeVolWgtSys"></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Chargaeable Volume Wgt By Airline</label>

                <b-form-input :formatter="capitalizeAll" v-model="consolModel.totalchargeVolWgtAir"></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="10"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Final Chargaeable/Billable Weight</label>
                <b-form-input :formatter="capitalizeAll" v-model="consolModel.totalfinalChargableWeight"></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>

          <!-- /.box-body -->
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>




<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";

import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Air Freight")) {
      this.$store.dispatch("setCurrentRoute", "/airFreight/cansolMasterMerge");
      this.viewFFExportFCL();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },

  data() {
    return {
      selectDateFormat,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok"
      },
      consolModel: {
        MAWBNumber: "",
        totalcargoGrossWeight: "",
        totalcargoVolumeWeight: "",
        totalchargeVolWgtAir: "",
        totalchargeVolWgtSys: "",
        totalfinalChargableWeight: ""
      },

      cansolMasterMergeTable: []
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  beforeDestroy() {},

  destroyed() {},

  components: {},

  computed: {},

  methods: {
    JqueryFun() {
      return $(function() {
        return $("#conBooking").DataTable();
      });
    },

    viewExportAirPage(FCLAir) {
      this.$sessionsStorage.set("editffAirExport", FCLAir);

      this.$router.push({
        path: "/airFreight/airFFExportConsol"
      });
    },
    viewFFExportFCL() {
      let payload = {
        airFcExportId: this.$sessionsStorage.get("editffAirExport")
      };
      // console.log("sasas",payload)
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_AirExport/viewConsolMaster.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log("avccc", data);
            if (data.consoleMAsterData.length > 0) {
              this.cansolMasterMergeTable = data.consoleMAsterData;
            }
            if (data.consolAllVal.length > 0) {
              Object.keys(this.consolModel).map(x => {
                this.consolModel[x] = data.consolAllVal[0][x] || "";
              });
            }

            this.JqueryFun();
          }
        })
        .catch(error => {});
    },
    previousEx() {
      this.$router.push({
        path: "/airFreight/airFreightExecution"
      });
    }
  }
};
</script>
<style>
</style>




// WEBPACK FOOTER //
// cansolMasterMerge.vue?e9b3e5ca